import { OrderModel } from "../../../pages/shared/models/order/order-item.model";
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { ToolPanel } from "../../../pages/orders/my/tool-panel/tool-panel";
import { OrderCardsContainer } from "../../../pages/orders/my/order-cards/styled";
import { GroupCard } from "./group-card/group-card";
import { changePagination, getOrderGroups } from "../../../redux/slices/order-group.slice";
import BarekamPagination from "../../../pages/orders/my/pagination/barekam-pagination";

const GroupCards = () => {
    const { orderStateId } = useAppSelector(state => state.ordersReducer);
    const { data: { groups, totalItems, pageSize, currentPage } } = useAppSelector(state => state.orderGroupReducer);
    const [selectedOrders] = useState(new Map<number, OrderModel>());

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getOrderGroups({ page: 0, forceLoad: true, orderStateId: orderStateId as number }));
    }, [])

    function handlePageChange(event: any, newPage: number): void {
        dispatch(changePagination({ pageSize, currentPage: newPage - 1 }));
        dispatch(getOrderGroups({ page: newPage - 1, orderStateId: orderStateId as number }));
    }

    return (
        <OrderCardsContainer>
            <ToolPanel selectedOrders={selectedOrders} isWarehouseWorker={true} orderStateId={orderStateId} />

            {groups.length
                ? <Grid container
                    gridTemplateColumns={'repeat(auto-fill, minmax(22rem, 1fr))'}
                    display={'grid'}
                    rowGap={'1rem'}
                    columnGap={'1rem'}
                    padding={'1rem'}>
                    {groups.map(group =>
                        <GroupCard group={group} key={group.ordersGroupId} />
                    )}
                </Grid>
                : <></>
            }

            <BarekamPagination totalItems={totalItems}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={handlePageChange} />
        </OrderCardsContainer>
    )
}

export default GroupCards;
